// extracted by mini-css-extract-plugin
export default {"tableAvatar":"userTable_tableAvatar__ioB-D","tableAvatar__img":"userTable_tableAvatar__img__GFWqK","rank":"userTable_rank__20PqY","rankDown":"userTable_rankDown__2geaH"};